var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useAIHubEnabled } from '@office-start/ai-hub-config-service';
import { useStandaloneCopilotApp } from '@office-start/copilot-route-service';
import { useFeatureGates } from '@office-start/feature-gates-service';
import { useFeatureSettings } from '@office-start/feature-settings-service';
import { useAdminPolicy } from '@office-start/harmony-data-service';
import { useIdentity } from '@office-start/identity-service';
import { RouterStatsContext, useRouterStats, } from '@office-start/telemetry-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import React, { useMemo } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
export var OfficeHomeAppRouteComponent = function (_a) {
    var officeHomeAppRouteConfig = _a.officeHomeAppRouteConfig, rootPath = _a.rootPath;
    var featureGates = useFeatureGates().data;
    var featureSettings = useFeatureSettings().data;
    var userEntitlements = useUserEntitlements().data;
    var identity = useIdentity().data;
    var adminPolicy = useAdminPolicy();
    var isAIHubEnabled = useAIHubEnabled(rootPath);
    var isStandaloneCopilot = useStandaloneCopilotApp();
    var routerStats = useRouterStats();
    var routeJsx = useMemo(function () {
        if (!featureGates ||
            !featureSettings ||
            !userEntitlements ||
            !identity) {
            //TODO: Add loading indicator
            return null;
        }
        if (!identity.isMsa && !adminPolicy && !isStandaloneCopilot) {
            return null;
        }
        var entitlementsResult = userEntitlements.result;
        var featureSettingsResult = featureSettings.result;
        var featureGatesResult = featureGates.result;
        var resolvedRouteJsx = officeHomeAppRouteConfig
            .map(function (routeItem, index) {
            var canActivate = true;
            var guardFunction = routeItem.guard;
            var resolvedRoute = __assign({}, routeItem.route);
            if (guardFunction) {
                var guardedRoute = guardFunction({
                    path: routeItem.route.path,
                    featureGates: featureGatesResult,
                    featureSettings: featureSettingsResult,
                    userEntitlements: entitlementsResult,
                    userIdentity: identity,
                    adminPolicy: adminPolicy,
                    isAIHubEnabled: isAIHubEnabled,
                });
                canActivate = guardedRoute.canActivate;
                // Handle scenarios that need to updat paths predefined in the route config
                var shouldUpdatePath = guardedRoute.shouldUpdatePath, updatedPath = guardedRoute.updatedPath;
                if (canActivate && shouldUpdatePath) {
                    if (!updatedPath ||
                        (Array.isArray(updatedPath) &&
                            updatedPath.length === 0)) {
                        canActivate = false;
                    }
                    else {
                        resolvedRoute.path = updatedPath;
                    }
                }
            }
            return canActivate ? (React.createElement(Route, __assign({ key: index }, resolvedRoute))) : null;
        })
            .filter(function (route) { return route !== null; });
        return (React.createElement(RouterStatsContext.Provider, { value: routerStats },
            React.createElement(Switch, null,
                resolvedRouteJsx,
                React.createElement(Route, { path: "*" },
                    React.createElement(Redirect, { to: rootPath })))));
    }, [
        featureGates,
        featureSettings,
        identity,
        officeHomeAppRouteConfig,
        rootPath,
        userEntitlements,
        isAIHubEnabled,
        adminPolicy,
    ]);
    return routeJsx;
};
//# sourceMappingURL=OfficeHomeAppRouteComponent.js.map